import { Theme } from '@amzn/awsui-components-core/theming';

/**
 * Cloudscape theme constants.
 * The font string MUST match the CSS custom property --font-family-base in src/styles/_typography.scss.
 */
export const FONT_FAMILY_BASE = "'Ember Modern Text', 'Amazon Ember', 'Helvetica Neue', Roboto, Arial, sans-serif";

export const APP_THEME: Theme = {
  tokens: {
    fontFamilyBase: FONT_FAMILY_BASE
    // colorBackgroundButtonPrimaryDefault: '{colorBorderButtonNormalDefault}',
    // colorBackgroundButtonPrimaryActive: '{colorBorderButtonNormalActive}',
    // colorBackgroundButtonPrimaryHover: '{colorBorderButtonNormalHover}',
    // colorTextButtonPrimaryDefault: '{colorTextInverted}',
    // colorTextButtonPrimaryActive: '{colorTextInverted}',
    // colorTextButtonPrimaryHover: '{colorTextInverted}'
  }
};
